import { PremiumCurrencyApiClient } from '@wix/premium-fed-sdk/@api-clients-react';
import { convertCurrencySettings } from '../utils';
export const queryCurrencySettings = async _ref => {
  let {
    httpClient
  } = _ref;
  const {
    currencySettings
  } = await PremiumCurrencyApiClient.query.getCurrencySettings({
    httpClient,
    request: {}
  });
  return {
    currencySettings: currencySettings
  };
};
export const queryCurrencySettingsLegacy = async _ref2 => {
  let {
    httpClient
  } = _ref2;
  const {
    currencySettings: currencySettingsV2
  } = await PremiumCurrencyApiClient.query.getCurrencySettings({
    httpClient,
    request: {}
  });
  const currencySettings = convertCurrencySettings(currencySettingsV2);
  return {
    currencySettings: currencySettings
  };
};
//# sourceMappingURL=queryCurrencySettings.js.map